<article class="ui-list-item tw:min-w-0 tw:rounded-app-xl tw:bg-app-white"
  [class.ui-list-item-compact]="compact()">
  <div class="ui-list-item-primary-row tw:grid tw:min-w-0">
    <div class="ui-list-item-main tw:min-w-0 tw:grid tw:gap-app-2">
      <h3>{{ title() }}</h3>
      @if (subtitle() || meta()) {
        <p class="ui-list-item-meta-line tw:flex-wrap tw:gap-app-2 tw:leading-app-normal">
          @if (subtitle()) {
            <span>{{ subtitle() }}</span>
          }
          @if (meta()) {
            <span class="ui-list-item-meta">{{ meta() }}</span>
          }
        </p>
      }
    </div>

    <div class="ui-list-item-trailing tw:items-center tw:gap-app-2 tw:min-w-0">
      @if (trailing()) {
        <span class="ui-list-item-trailing-text tw:text-app-text tw:leading-app-normal tw:whitespace-nowrap">{{ trailing() }}</span>
      }
      <ng-content select="[itemTrailing]"></ng-content>
    </div>
  </div>

  <div class="ui-list-item-secondary-row tw:min-w-0">
    @if (secondary()) {
      <p>{{ secondary() }}</p>
    }
    <ng-content select="[itemSecondary]"></ng-content>
  </div>
</article>
